import $ from 'jquery';
import store from '../store';
import TypeUtils from '@/common/utils/TypeUtils';

const TIMEOUT = 30000;

class ResponseError {
  constructor(response, url) {
    this._url = url;
    this._response = response;
    this._isStopPropagation = false;
  }
  response() {
    return this._response;
  }
  stopPropagation() {
    this._isStopPropagation = true;
  }
  isStopPropagation() {
    return this._isStopPropagation;
  }
}

let loader = {
  beforeRequest: () => {
    return null;
  },
  networkErrorHandler: () => {},
  responseHandler(url, res, syncErrorCallback, resolve, reject) {
    if (res == null) {
      console.warn('There are no response.');
      return;
    }
    let parsedRes = (TypeUtils.isString(res) && res.length > 0) ? JSON.parse(res) : res;
    if (parsedRes && (parsedRes.succ || parsedRes.errorcode === 0 || parsedRes.error_code === 0)) {
      resolve(parsedRes.data || parsedRes);
    } else {
      errorHandler(parsedRes, syncErrorCallback, reject, url);
    }
  },

  get(url, data, syncErrorCallback) {
    let param = [];
    if (data) {
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          let value = data[key];
          if (value == null) {
            continue;
          } else if (TypeUtils.isArray(value)) {
            value.forEach((val) => {
              param.push(key + '[]=' + val);
            });
          } else {
            param.push(key + '=' + value);
          }
        }
      }
    }
    return new Promise((resolve, reject) => {
      let result = this.beforeRequest();
      if (result != null) {
        reject(result);
        return;
      }
      $.ajax({
        type: 'GET',
        url: url,
        data: param.join('&'),
        headers: {
          token: (store.state.open && store.state.open.user && store.state.open.user.token) || localStorage.getItem('token') || ''
        },
        timeout: TIMEOUT,
        processData: false,
        success: (res) => {
          this.responseHandler(url, res, syncErrorCallback, resolve, reject);
        },
        error: (res) => {
          errorHandler(res, syncErrorCallback, reject, url);
          reject(res);
        }
      });
    });
  },

  post(url, data, syncErrorCallback) {
    let param = [];
    for (let key in data) {
      if (data[key] instanceof Array) {
        for (let i = 0; i < data[key].length; i++) {
          param.push(key + '[]=' + data[key][i]);
        }
      } else {
        param.push(key + '=' + data[key]);
      }
    }
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: url,
        timeout: TIMEOUT,
        data: param.join('&'),
        headers: {
          token: (store.state.open && store.state.open.user && store.state.open.user.token) || localStorage.getItem('token') || ''
        },
        processData: false,
        success: (res) => {
          this.responseHandler(url, res, syncErrorCallback, resolve, reject);
        },
        error: (res) => {
          errorHandler(res, syncErrorCallback, reject, url);
        }
      });
    });
  },

  jsonPost(url, data, headers, syncErrorCallback, options) {
    return new Promise((resolve, reject) => {
      var xhr = $.ajax({
        type: 'POST',
        url: url,
        timeout: 6000000,
        headers: {
          'Content-Type': 'text/json',
          ...headers,
          token: (store.state.open && store.state.open.user && store.state.open.user.token) || localStorage.getItem('token') || ''
        },
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(data),
        success: (res) => {
          this.responseHandler(url, res, syncErrorCallback, resolve, reject);
        },
        error: (res) => {
          errorHandler(res, syncErrorCallback, reject, url);
        }
      });
      if (options) {
        options.xhr = xhr;
      }
    });
  },

  upload(url, data, files, syncErrorCallback) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      if (files) {
        Object.keys(files).forEach((key) => {
          let fileVal = files[key];
          if (TypeUtils.isArray(fileVal)) {
            for (let i = 0; i < fileVal.length; i++) {
              formData.append(key + '[]', fileVal[i]);
            }
          } else {
            formData.append(key, files[key]);
          }
        });
      }
      if (data) {
        Object.keys(data).forEach(function(key) {
          let val = data[key];
          if (TypeUtils.isArray(val) && TypeUtils.isObject(val[0])) {
            for (let i = 0; i < val.length; i++) {
              Object.keys(val[i]).forEach((subKey) => {
                formData.append(`${key}[${i}][${subKey}]`, val[i][subKey]);
              });
            }
          } else if (TypeUtils.isArray(val)) {
            for (let i = 0; i < val.length; i++) {
              formData.append(key + '[]', val[i]);
            }
          } else {
            formData.append(key, data[key]);
          }
        });
      }
      $.ajax({
        type: 'POST',
        url: url,
        timeout: TIMEOUT,
        data: formData,
        headers: {
          token: (store.state.open && store.state.open.user && store.state.open.user.token) || localStorage.getItem('token') || ''
        },
        processData: false,
        cache: false,
        contentType: false,
        success: (res) => {
          this.responseHandler(url, res, syncErrorCallback, resolve, reject);
        },
        error: (res) => {
          errorHandler(res, syncErrorCallback, reject, url);
        }
      });
    });
  },

  downloadFile(url, params) {
    var downloadContainer = document.getElementById('downloadForms');
    var downloadForm = document.createElement('form');
    downloadContainer.appendChild(downloadForm);
    downloadForm.action = url;
    downloadForm.method = 'post';
    downloadForm.target = 'downloadTarget';
    for (var name in params) {
      if (params.hasOwnProperty(name)) {
        if (params[name] instanceof Array) {
          for (let i = 0; i < params[name].length; i++) {
            let child = document.createElement('input');
            child.type = 'hidden';
            child.name = name + '[]';
            child.value = params[name][i];
            downloadForm.appendChild(child);
          }
        } else {
          let child = document.createElement('input');
          child.type = 'hidden';
          child.name = name;
          child.value = params[name];
          downloadForm.appendChild(child);
        }
      }
    }
    downloadForm.submit();

    downloadContainer.removeChild(downloadForm);
  },

  downloadFileValidate(url, data, licensename, syncErrorCallback) {
    let param = [];
    if (data) {
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          let value = data[key];
          if (value == null) {
            continue;
          } else if (TypeUtils.isArray(value)) {
            value.forEach((val) => {
              param.push(key + '[]=' + val);
            });
          } else {
            param.push(key + '=' + value);
          }
        }
      }
    }
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: url,
        timeout: TIMEOUT,
        data: param.join('&'),
        cache: false,
        headers: {
          token: (store.state.open && store.state.open.user && store.state.open.user.token) || localStorage.getItem('token') || ''
        },
        xhrFields: {
          responseType: 'blob'
        },
        processData: false,
        success: (res) => {
          let data = res;
          let download = 'license.lic';
          if (typeof licensename !== 'undefined' && licensename !== '') {
            download = licensename;
          }
          const blob = new Blob([data]);
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, download);
            return;
          }
          let a = document.createElement('a');
          const href = window.URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = href;
          a.download = download;
          a.click();
          window.URL.revokeObjectURL(href);
        },
        error: (res) => {
          errorHandler(res, syncErrorCallback, reject, url);
        }
      });
    });
  }
};

function errorHandler(response, syncErrorCallback, promiseReject, url) {
  const error = new ResponseError(response, url);
  if (syncErrorCallback) {
    syncErrorCallback(error);
  }
  if (!error.isStopPropagation()) {
    loader.networkErrorHandler(error);
  }
  promiseReject(error);
};

export default loader;



// WEBPACK FOOTER //
// ./src/common/loader.js